import CourseDetailsTab from './CourseDetailsTab';

export default CourseDetailsTab;
